import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';

function* fetchSiloEquipmentData({ silosEquipmentParams }) {
  try {
    const { data } = yield call(api.get, {
      route: `silos/dashboard/${silosEquipmentParams.equipmentId}`,
    });
    const siloEquipmentData = data;
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setSiloEquipmentData({ siloEquipmentData }));
  } catch (error) {
    console.warn(error); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_SILO_EQUIPMENT_DATA, fetchSiloEquipmentData)]);
}
